import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../repositories/auth.repository';

/**
 * Use case para inicializar o MSAL
 * Baseado no inicializar_msal_usecase.dart do Flutter
 */
@Injectable({
  providedIn: 'root'
})
export class InicializarMsalUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Executa a inicialização do MSAL
   * @returns Observable<boolean> - true se inicializado com sucesso
   */
  execute(): Observable<boolean> {
    return this.authRepository.initializeMsal();
  }
}
